export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/1c4f4c068501a2b5c3621e5e1fdd9419.png";